exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-child-container[data-v-2e9d2346]{margin-bottom:30px}", ""]);

// exports
